<template>
  <div id="stent-talent-toevoegen">
    <div v-if="!done">
      <form class="" v-on:submit.prevent="submit">
        <div class="row g-4 gy-md-5 gx-md-6 mb-6">
          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.voornaam.length > 0}">
              <label>Voornaam <span class="requirement">(verplicht)</span></label>
              <input class="form-control" type="text"  v-model="form.data.voornaam" _required>

              <ul v-if="form.errors.voornaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voornaam" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.voorvoegsels.length > 0}">
              <label>Tussenvoegsel</label>
              <input class="form-control" type="text" v-model="form.data.voorvoegsels">

              <ul v-if="form.errors.voorvoegsels.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voorvoegsels" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.voorvoegsels.length > 0}">
              <label>Achternaam <span class="requirement">(verplicht)</span></label>
              <input class="form-control" type="text" v-model="form.data.achternaam" _required>

              <ul v-if="form.errors.achternaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.achternaam" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-user"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container email-container" :class="{'error': form.errors.email.length > 0}">
              <label>E-mailadres <span class="requirement">(verplicht)</span></label>
              <input class="form-control" type="email" v-model="form.data.email" _required>

              <ul v-if="form.errors.email.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.email" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-envelope"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-file" :class="{'error': form.errors.pictures.length > 0}">
              <label>Foto's <span class="requirement">(verplicht)</span></label>
              <input class="form-control" id="pictures" type="file" ref="pictures" multiple @change="setPicturesFiles" accept=".png,.jpg,.jpeg,.gif,.webp,.bmp" _required>
              <label for="pictures">
                <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
              </label>

              <table v-if="form.data.pictures.length > 0" class="stt-upload-table">
                <tr v-for="(file, index) in form.data.pictures" :key="file">
                  <td class="stt-upload-table-filename">
                    <span>{{ file.name }}</span>
                  </td>

                  <td class="stt-upload-table-remove" @click="removePicturesFile(index)">
                    <span>X</span>
                  </td>
                </tr>
              </table>

              <ul v-if="form.errors.pictures.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.pictures" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <template v-for="n in 5">
                <ul v-if="form.errors[`pictures.${n - 1}`] !== undefined" :key="n" class="stent-form-errors">
                  <li v-for="error in form.errors[`pictures.${n - 1}`]" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
              </template>

              <i class="btb bt-photo"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-file" :class="{'error': form.errors.documents.length > 0}">
              <label>C.V.</label>
              <input class="form-control" id="documents" type="file" ref="documents" data-upload-type="cv" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.rtf,.txt" @change="setDocumentsFiles">
              <label for="documents">
                <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
              </label>

              <table v-if="form.data.documents.length > 0" class="stt-upload-table">
                <tr v-for="(file, index) in form.data.documents" :key="file">
                  <td class="stt-upload-table-filename">
                    <span>{{ file.name }}</span>
                  </td>

                  <td class="stt-upload-table-remove" @click="removeDocumentsFile(index)">
                    <span>X</span>
                  </td>
                </tr>
              </table>

              <ul v-if="form.errors.documents.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.documents" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

              <template v-for="n in 5">
                <ul v-if="form.errors[`documents.${n - 1}`] !== undefined" :key="n" class="stent-form-errors">
                  <li v-for="error in form.errors[`documents.${n - 1}`]" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
              </template>
            </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Inschrijvingen</h5>
            </div>
          </div>

          <div class="col-12">
            <div class="input-container checkbox">

              <div class="row g-4 gy-lg-3 gx-lg-6">

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.acteur.length > 0}">
                      <input v-model="form.data.acteur" type="checkbox" id="acteur" name="acteur">
                      <label for="acteur">Acteur</label>

                      <ul v-if="form.errors.acteur.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.acteur" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.zanger.length > 0}">
                      <input v-model="form.data.zanger" type="checkbox" id="zanger" name="zanger" value="false">
                      <label for="zanger">Zanger</label>

                      <ul v-if="form.errors.zanger.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.zanger" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.model.length > 0}">
                      <input v-model="form.data.model" type="checkbox" id="model" name="model">
                      <label for="model">Model</label>

                      <ul v-if="form.errors.model.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.model" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.figurant.length > 0}">
                      <input v-model="form.data.figurant" type="checkbox" id="figurant" name="figurant">
                      <label for="figurant">Figurant</label>

                      <ul v-if="form.errors.figurant.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.figurant" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.presentator.length > 0}">
                      <input v-model="form.data.presentator" type="checkbox" id="presentator" name="presentator">
                      <label for="presentator">Presentator</label>

                      <ul v-if="form.errors.presentator.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.presentator" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.entertainer.length > 0}">
                      <input v-model="form.data.entertainer" type="checkbox" id="entertainer" name="entertainer">
                      <label for="entertainer">Entertainer</label>

                      <ul v-if="form.errors.entertainer.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.entertainer" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.danser.length > 0}">
                      <input v-model="form.data.danser" type="checkbox" id="danser" name="danser">
                      <label for="danser">Danser</label>

                      <ul v-if="form.errors.danser.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.danser" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.musical_acteur.length > 0}">
                      <input v-model="form.data.musical_acteur" type="checkbox" id="musical_acteur" name="musical_acteur">
                      <label for="musical_acteur">Musicalacteur</label>

                      <ul v-if="form.errors.musical_acteur.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.musical_acteur" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Goedkeuringen</h5>
            </div>
          </div>

          <div class="col-12">
            <div class="input-container checkbox">

              <div class="row g-4 gy-lg-3 gx-lg-6">

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.av.length > 0}">
                      <input v-model="form.data.av" type="checkbox" id="av" name="av">
                      <label for="av">Algemene voorwaarden</label>

                      <ul v-if="form.errors.av.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.av" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.privacy.length > 0}">
                      <input v-model="form.data.privacy" type="checkbox" id="privacy" name="privacy">
                      <label for="privacy">Privacywet</label>

                      <ul v-if="form.errors.privacy.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.privacy" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="checkbox-container" :class="{'error': form.errors.social_media.length > 0}">
                      <input v-model="form.data.social_media" type="checkbox" id="social_media" name="social_media">
                      <label for="social_media">Sociale media</label>

                      <ul v-if="form.errors.social_media.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.social_media" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Algemene gegevens</h5>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.geslacht.length > 0}">
              <label class="form-label">Geslacht <span class="requirement">(verplicht)</span></label>

              <select v-model="form.data.geslacht" class="form-select stt-field-input" _required>
                <option :value="''">Maak een keuze</option>

                <option :value="geslacht.key" v-for="geslacht in dropdowns.geslachten" :key="geslacht">
                  {{ geslacht.value }}
                </option>
              </select>

              <ul v-if="form.errors.geslacht.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geslacht" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-date" :class="{'error': form.errors.geboortedatum.length > 0}">
              <label>Geboortedatum <span class="requirement">(verplicht)</span></label>
              <input class="form-control stt-field-input" type="date" v-model="form.data.geboortedatum" placeholder="Voorbeeld: 24-09-1997" _required>

              <ul v-if="form.errors.geboortedatum.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geboortedatum" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container" :class="{'error': form.errors.telefoonnummer.length > 0}">
                <label>Telefoonnummer <span class="requirement">(verplicht)</span></label>
                <input class="form-control stt-field-input" type="text" v-model="form.data.telefoonnummer" _required>

                <ul v-if="form.errors.telefoonnummer.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.telefoonnummer" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container" :class="{'error': form.errors.straatnaam.length > 0}">
                <label>Straatnaam <span class="requirement">(verplicht)</span></label>
                <input class="form-control stt-field-input" type="text" v-model="form.data.straatnaam" _required>

                <ul v-if="form.errors.straatnaam.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.straatnaam" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
              <div class="input-container" :class="{'error': form.errors.huisnummer.length > 0}">
                <label>Huisnummer <span class="requirement">(verplicht)</span></label>
                <input class="form-control stt-field-input" type="number" v-model="form.data.huisnummer" _required>

                <ul v-if="form.errors.huisnummer.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.huisnummer" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
              <div class="input-container" :class="{'error': form.errors.huisnummer_toevoeging.length > 0}">
                <label>Huisnummer toevoeging</label>
                <input class="form-control stt-field-input" type="text" v-model="form.data.huisnummer_toevoeging">

                <ul v-if="form.errors.huisnummer_toevoeging.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.huisnummer_toevoeging" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
              <div class="input-container" :class="{'error': form.errors.postcode.length > 0}">
                <label>Postcode <span class="requirement">(verplicht)</span></label>
                <input class="form-control stt-field-input" type="text" v-model="form.data.postcode" _required>

                <ul v-if="form.errors.postcode.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.postcode" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.plaats.length > 0}">
              <label>Plaats <span class="requirement">(verplicht)</span></label>
              <input class="form-control stt-field-input" type="text" v-model="form.data.plaats" _required>

              <ul v-if="form.errors.plaats.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.plaats" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.land.length > 0}">
              <label class="form-label">Land <span class="requirement">(verplicht)</span></label>

              <select v-model="form.data.land" class="form-select stt-field-input" _required>
                <option :value="''">Maak een keuze</option>

                <option :value="land.code" v-for="land in dropdowns.landen" :key="land">
                  {{ land.land }}

                </option>
              </select>

              <ul v-if="form.errors.land.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.land" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
              <div class="input-container radiobox" :class="{'error': form.errors.rijbewijs.length > 0}">
                <label class="form-label">Rijbewijs <span class="requirement">(verplicht)</span></label>
                  <div class="row g-4 gy-md-3 gx-md-6">
                      <div class="col-auto" v-for="boolean in dropdowns.booleans" :key="boolean">
                          <div class="radio-container">
                                <input v-model="form.data.rijbewijs" type="radio" :id="'rijbewijs-' + boolean.key" name="rijbewijs" :value="boolean.key">
                              <label :for="'rijbewijs-' + boolean.key">{{ boolean.value }}</label>
                          </div>
                      </div>
                      <ul v-if="form.errors.rijbewijs.length > 0" class="stent-form-errors">
                        <li v-for="error in form.errors.rijbewijs" :key="error" class="stt-field-error">{{ error }}</li>
                      </ul>
                  </div>
              </div>
          </div>


          <div class="col-12">
            <div class="separator-title-container">
              <h5>Kenmerken</h5>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.uiterlijk.length > 0}">
              <label class="form-label">Afkomst</label>

              <select v-model="form.data.uiterlijk" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option 
                  :value="uiterlijk.id" 
                  v-for="uiterlijk in dropdowns.filteredUiterlijken" 
                  :key="uiterlijk"
                >
                  {{ uiterlijk.afkomst }}
                </option>
              </select>

              <ul v-if="form.errors.uiterlijk.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.uiterlijk" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.oogkleur.length > 0}">
              <label class="form-label">Oogkleur</label>

              <select v-model="form.data.oogkleur" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option :value="oogkleur.id" v-for="oogkleur in dropdowns.kleuren.oog" :key="oogkleur">
                  {{ oogkleur.kleur }}
                </option>
              </select>

              <ul v-if="form.errors.oogkleur.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.oogkleur" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>



          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.lengte_in_cm.length > 0}">
              <label class="stt-field-label">Lengte in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.lengte_in_cm" min="0">

              <ul v-if="form.errors.lengte_in_cm.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.lengte_in_cm" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.gewicht_in_kg.length > 0}">
              <label class="stt-field-label">Gewicht in KG</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.gewicht_in_kg" min="0">

              <ul v-if="form.errors.gewicht_in_kg.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.gewicht_in_kg" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.haarkleur.length > 0}">
              <label class="form-label stt-field-label">Haarkleur</label>

              <select v-model="form.data.haarkleur" class="form-select stt-field-input">
              <option :value="''">Maak een keuze</option>

              <option :value="haarkleur.id" v-for="haarkleur in dropdowns.kleuren.haar" :key="haarkleur">
                {{ haarkleur.kleur }}
              </option>
            </select>

            <ul v-if="form.errors.haarkleur.length > 0" class="stent-form-errors">
              <li v-for="error in form.errors.haarkleur" :key="error" class="stt-field-error">{{ error }}</li>
            </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.haarstijl.length > 0}">
              <label class="form-label stt-field-label">Haarstijl</label>

              <select v-model="form.data.haarstijl" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option :value="haarstijl.id" v-for="haarstijl in dropdowns.haarstijlen" :key="haarstijl">
                  {{ haarstijl.haarstijl }}
                </option>
              </select>

              <ul v-if="form.errors.haarstijl.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.haarstijl" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.haarlengte.length > 0}">
              <label class="stt-field-label">Haarlengte in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.haarlengte" min="0">

              <ul v-if="form.errors.haarlengte.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.haarlengte" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container radiobox" :class="{'error': form.errors.bril.length > 0}">
                <label class="form-label">Bril</label>
                  <div class="row g-4 gy-md-3 gx-md-6">
                      <div class="col-auto" v-for="boolean in dropdowns.booleans" :key="boolean">
                          <div class="radio-container">
                                <input v-model="form.data.bril" type="radio" :id="'bril-' + boolean.key" name="bril" :value="boolean.key">
                              <label :for="'bril-' + boolean.key">{{ boolean.value }}</label>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container radiobox" :class="{'error': form.errors.lenzen.length > 0}">
                <label class="form-label">Lenzen</label>
                  <div class="row g-4 gy-md-3 gx-md-6">
                      <div class="col-auto" v-for="boolean in dropdowns.booleans" :key="boolean">
                          <div class="radio-container">
                                <input v-model="form.data.lenzen" type="radio" :id="'lenzen-' + boolean.key" name="lenzen" :value="boolean.key">
                              <label :for="'lenzen-' + boolean.key">{{ boolean.value }}</label>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container radiobox" :class="{'error': form.errors.snor.length > 0}">
                <label class="form-label">Snor</label>
                  <div class="row g-4 gy-md-3 gx-md-6">
                      <div class="col-auto" v-for="boolean in dropdowns.booleans" :key="boolean">
                          <div class="radio-container">
                                <input v-model="form.data.snor" type="radio" :id="'snor-' + boolean.key" name="snor" :value="boolean.key">
                              <label :for="'snor-' + boolean.key">{{ boolean.value }}</label>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-sm-6 col-md-4">
              <div class="input-container radiobox" :class="{'error': form.errors.baard.length > 0}">
                <label class="form-label">Baard</label>
                  <div class="row g-4 gy-md-3 gx-md-6">
                      <div class="col-auto" v-for="boolean in dropdowns.booleans" :key="boolean">
                          <div class="radio-container">
                                <input v-model="form.data.baard" type="radio" :id="'baard-' + boolean.key" name="baard" :value="boolean.key">
                              <label :for="'baard-' + boolean.key">{{ boolean.value }}</label>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="col-12">
            <div class="separator-title-container">
              <h5>Maten</h5>
            </div>
          </div>

          <div class="col-sm-6 col-md-6">
            <div class="input-container selectbox" :class="{'error': form.errors.kledingmaat_boven.length > 0}">
              <label class="form-label stt-field-label">Kledingmaat boven</label>

              <select v-model="form.data.kledingmaat_boven" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option :value="kledingmaat.id" v-for="kledingmaat in dropdowns.kledingmaten" :key="kledingmaat">
                  {{ kledingmaat.kledingmaat }}
                </option>
              </select>

              <ul v-if="form.errors.kledingmaat_boven.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.kledingmaat_boven" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-6">
            <div class="input-container selectbox" :class="{'error': form.errors.kledingmaat_onder.length > 0}">
              <label class="form-label stt-field-label">Kledingmaat onder</label>

              <select v-model="form.data.kledingmaat_onder" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option :value="kledingmaat.id" v-for="kledingmaat in dropdowns.kledingmaten" :key="kledingmaat">
                  {{ kledingmaat.kledingmaat }}
                </option>
              </select>

              <ul v-if="form.errors.kledingmaat_onder.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.kledingmaat_onder" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>


          <div class="col-sm-6 col-md-6">
            <div class="input-container" :class="{'error': form.errors.broek_lengtemaat.length > 0}">
              <label class="stt-field-label">Broek lengtemaat</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.broek_lengtemaat">

              <ul v-if="form.errors.broek_lengtemaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.broek_lengtemaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-6">
            <div class="input-container" :class="{'error': form.errors.broek_breedtemaat.length > 0}">
              <label class="stt-field-label">Broek breedtemaat</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.broek_breedtemaat">

              <ul v-if="form.errors.broek_breedtemaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.broek_breedtemaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.omtrek_hoofd_in_cm.length > 0}">
              <label class="stt-field-label">Omtrek hoofd in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.omtrek_hoofd_in_cm">

              <ul v-if="form.errors.omtrek_hoofd_in_cm.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.omtrek_hoofd_in_cm" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.omtrek_borst_in_cm.length > 0}">
              <label class="stt-field-label">Omtrek borst in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.omtrek_borst_in_cm">

              <ul v-if="form.errors.omtrek_borst_in_cm.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.omtrek_borst_in_cm" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.omtrek_taille_in_cm.length > 0}">
              <label class="stt-field-label">Omtrek taille in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.omtrek_taille_in_cm">

              <ul v-if="form.errors.omtrek_taille_in_cm.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.omtrek_taille_in_cm" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.omtrek_heup_in_cm.length > 0}">
              <label class="stt-field-label">Omtrek heup in CM</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.omtrek_heup_in_cm">

              <ul v-if="form.errors.omtrek_heup_in_cm.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.omtrek_heup_in_cm" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.boordmaat.length > 0}">
            <label class="stt-field-label">Boordmaat</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.boordmaat">

              <ul v-if="form.errors.boordmaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.boordmaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container selectbox" :class="{'error': form.errors.cupmaat.length > 0}">
              <label class="form-label stt-field-label">Cupmaat</label>

              <select v-model="form.data.cupmaat" class="form-select stt-field-input">
                <option :value="''">Maak een keuze</option>

                <option :value="cupmaat.id" v-for="cupmaat in dropdowns.cupmaten" :key="cupmaat">
                  {{ cupmaat.cupmaat }}
                </option>
              </select>

              <ul v-if="form.errors.cupmaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.cupmaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.cupmaat_omvangsmaat.length > 0}">
              <label class="stt-field-label">Cupmaat omvangsmaat</label>
              <input class="form-control stt-field-input" type="text" v-model="form.data.cupmaat_omvangsmaat">

              <ul v-if="form.errors.cupmaat_omvangsmaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.cupmaat_omvangsmaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>


          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.schoenmaat.length > 0}">
              <label class="stt-field-label">Schoenmaat</label>
              <input class="form-control stt-field-input" type="number" v-model="form.data.schoenmaat">

              <ul v-if="form.errors.schoenmaat.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.schoenmaat" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>


          <div class="col-12">
            <div class="separator-title-container">
              <h5>Bijzonderheden</h5>
            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container" :class="{'error': form.errors.bijzonderheden_uiterlijk.length > 0}">
              <label class="stt-field-label">Bijzonderheden uiterlijk</label>
              <textarea v-model="form.data.bijzonderheden_uiterlijk" class="form-control stt-field-input"></textarea>
              

              <ul v-if="form.errors.bijzonderheden_uiterlijk.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.bijzonderheden_uiterlijk" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container" :class="{'error': form.errors.sport_en_hobby.length > 0}">
              <label class="stt-field-label">Sport en hobby</label>
              <textarea v-model="form.data.sport_en_hobby" class="form-control stt-field-input"></textarea>

              <ul v-if="form.errors.sport_en_hobby.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.sport_en_hobby" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-md-4">
            <div class="input-container" :class="{'error': form.errors.bijzonderheden_overig.length > 0}">
              <label class="stt-field-label">Bijzonderheden overig</label>
              <textarea v-model="form.data.bijzonderheden_overig" class="form-control stt-field-input"></textarea>

              <ul v-if="form.errors.bijzonderheden_overig.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.bijzonderheden_overig" :key="error" class="stt-field-error">{{ error }}</li>
              </ul>

            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container">
              <div class="input-container" :class="{'error': form.errors.showreel.length > 0}">
                <label for="showreel">Showreel</label>
                <input v-model="form.data.showreel" type="text" name="showreel" id="showreel" class="form-control stt-field-input">

                <ul v-if="form.errors.showreel.length > 0" class="stent-form-errors">
                  <li v-for="error in form.errors.showreel" :key="error" class="stt-field-error">{{ error }}</li>
                </ul>
              </div>
            </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_voorwaarden.length > 0}">
                  <input v-model="form.data.akkoord_voorwaarden" type="checkbox" name="voorwaarden" id="voorwaarden">
                  <label for="voorwaarden">
                    Ik ga akkoord en bevestig dat ik op de hoogte ben van de <a href="/algemene-voorwaarden" target="_blank">Algemene voorwaarden</a>
                    en de <a href="/privacy-policy" target="_blank">Privacy policy</a>.
                  </label>

                  <ul v-if="form.errors.akkoord_voorwaarden.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_voorwaarden" :key="error" class="stt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_bijzondere_persoonsgegevens.length > 0}">
                  <input v-model="form.data.akkoord_bijzondere_persoonsgegevens" type="checkbox" name="akkoord_bijzondere_persoonsgegevens" id="akkoord_bijzondere_persoonsgegevens">
                  <label for="akkoord_bijzondere_persoonsgegevens">
                    Ja, ik geef toestemming voor het verwerken van door mij verstrekte en/of te verstrekken bijzondere persoonsgegevens ten behoeve van de castingprocedure van STENT Casting, zoals beschreven in het Privacy-en Cookiestatement.
                  </label>

                  <ul v-if="form.errors.akkoord_bijzondere_persoonsgegevens.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_bijzondere_persoonsgegevens" :key="error" class="stt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="cell large-4 input-container">
          <button class="btn btn-primary d-block ms-auto" type="submit" disabled>Aan het laden...</button>
        </div>
        <div v-else class="cell large-4 input-container">
          <button type="button" class="btn btn-primary d-block ms-auto" data-bs-toggle="modal" data-bs-target="#emailmodal">Verzenden</button>
        </div>
      </div>

      <EmailModal
        :email="this.form.data.email"
        :visible="showModal"
        @edit="editEmail"
        @send="sendSubmit"
      />
      </form>

      
    </div>

    <div v-if="done">
      <h1>Aanmelding voltooid</h1>

      <p>De aanmelding is gelukt.</p>
    </div>
  </div>
  
</template>

<style scoped>
.input-container {
  padding-bottom: 15px;
}

.stt-field-input {
  margin-bottom: 0;
}

.stt-upload-table {
  margin-top: 30px;
  font-size: 14px;
  width: 100%;
}

.stt-upload-table td {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stt-upload-table td.stt-upload-table-filename {
  width: 90%;
}

.stt-upload-table td.stt-upload-table-remove {
  width: 10%;
  color: red;
  font-weight: 900;
  cursor: pointer;
  text-align: right;
}

.form-talent-error-message {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}

#stent-talent-toevoegen input[type='file'] {
  width: 1px !important;
  height: 1px !important;
  opacity: 1 !important;
}

.requirement {
  color: #cacaca;
  margin: 0;
  display: inline-block;
  font-size: 14px;
}

.stent-form-errors {
  margin: 0;
  margin-top: 5px;
}

/* .stt-field-error {
  font-size: 14px;
  padding: 0;
} */

/* .stt-field-error::before {
  position: initial;
  display: initial;
  content: " ";
  font-family: Arial;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d9534f' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E");
  padding-right: 1.50rem;
  background-repeat: no-repeat;
  background-size: 1.125rem 1.125rem;
  background-clip: unset;
  background-position-y: -3px;
} */
</style>

<script>
import axios from 'axios';
import helpers from './utils/helpers';
import EmailModal from './components/EmailModal.vue';

export default {
  components: {
    EmailModal,
  },
  data() {
    return {
      dropdowns: {
        kleuren: {
          oog: [],
          haar: [],
        },
        booleans: [],
        geslachten: [],
        landen: [],
        kledingmaten: [],
        uiterlijken: [],
        cupmaten: [],
        haarstijlen: [],
      },

      form: {
        data: {
          voornaam: '',
          voorvoegsels: '',
          achternaam: '',
          email: '',
          pictures: [],
          documents: [],
          akkoord_voorwaarden: '',
          akkoord_bijzondere_persoonsgegevens: '',
          opdracht_id: '',

          // Inschrijvingen
          kandidaat: false,
          danser: false,
          acteur: false,
          musical_acteur: false,
          zanger: false,
          model: false,
          figurant: false,
          presentator: false,
          entertainer: false,

          // Goedkeuringen
          av: '',
          privacy: '',
          social_media: '',

          // Algemeen
          geslacht: '',
          geboortedatum: '',
          straatnaam: '',
          huisnummer: '',
          huisnummer_toevoeging: '',
          postcode: '',
          plaats: '',
          land: '',
          telefoonnummer: '',
          rijbewijs: '',

          // Kenmerken
          uiterlijk: '',
          oogkleur: '',
          lengte_in_cm: '',
          gewicht_in_kg: '',
          haarkleur: '',
          haarstijl: '',
          haarlengte: '',
          kledingmaat_boven: '',
          kledingmaat_onder: '',
          broek_lengtemaat: '',
          broek_breedtemaat: '',
          omtrek_hoofd_in_cm: '',
          omtrek_borst_in_cm: '',
          omtrek_taille_in_cm: '',
          omtrek_heup_in_cm: '',
          boordmaat: '',
          cupmaat: '',
          cupmaat_omvangsmaat: '',
          schoenmaat: '',
          bril: '',
          lenzen: '',
          snor: '',
          baard: '',
          bijzonderheden_uiterlijk: '',
          sport_en_hobby: '',
          bijzonderheden_overig: '',
          showreel: '',
        },

        errors: {
          voornaam: [],
          voorvoegsels: [],
          achternaam: [],
          email: [],
          pictures: [],
          documents: [],
          akkoord_voorwaarden: [],
          akkoord_bijzondere_persoonsgegevens: [],
          showreel: [],

          // Inschrijvingen
          kandidaat: [],
          danser: [],
          acteur: [],
          musical_acteur: [],
          zanger: [],
          model: [],
          figurant: [],
          presentator: [],
          entertainer: [],

          // Goedkeuringen
          av: [],
          privacy: [],
          social_media: [],

          // Algemeen
          geslacht: [],
          geboortedatum: [],
          straatnaam: [],
          huisnummer: [],
          huisnummer_toevoeging: [],
          postcode: [],
          plaats: [],
          land: [],
          telefoonnummer: [],
          rijbewijs: [],

          // Kenmerken
          uiterlijk: [],
          oogkleur: [],
          lengte_in_cm: [],
          gewicht_in_kg: [],
          haarkleur: [],
          haarstijl: [],
          haarlengte: [],
          kledingmaat_boven: [],
          kledingmaat_onder: [],
          broek_lengtemaat: [],
          broek_breedtemaat: [],
          omtrek_hoofd_in_cm: [],
          omtrek_borst_in_cm: [],
          omtrek_taille_in_cm: [],
          omtrek_heup_in_cm: [],
          boordmaat: [],
          cupmaat: [],
          cupmaat_omvangsmaat: [],
          schoenmaat: [],
          bril: [],
          lenzen: [],
          snor: [],
          baard: [],
          bijzonderheden_uiterlijk: [],
          sport_en_hobby: [],
          bijzonderheden_overig: [],
        },

        response: {},
      },

      done: false,
      loading: false,
      submitted: false,
    };
  },
  

  mounted() {
    if (helpers.attribute('opdracht_id') !== undefined) {
      this.form.data.opdracht_id = helpers.attribute('opdracht_id');
    }

    if (!helpers.attribute('api_endpoint')) return;

    this.retrieveKleuren();
    this.retrieveBooleans();
    this.retrieveGeslachten();
    this.retrieveLanden();
    this.retrieveKledingmaten();
    this.retrieveUiterlijken();
    this.retrieveCupmaten();
    this.retrieveHaarstijlen();
  },
  computed: {
    filteredUiterlijken() {
      return this.dropdowns.uiterlijken.filter(uiterlijk => uiterlijk.afkomst !== 'Europees');
    }
  },

  methods: {
    sendSubmit: function () {
      this.loading = true;
      this.submit();
    },
    editEmail: function () {
      this.loading = false;

      helpers.scrollIntoView('.email-container', {
        block: 'center',
      });
    },
    retrieveBooleans: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/booleans`)
        .then((response) => {
          this.dropdowns.booleans = response.data;
        });
    },

    retrieveGeslachten: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/geslachten`)
        .then((response) => {
          this.dropdowns.geslachten = response.data;
        });
    },

    retrieveLanden: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/landen`)
        .then((response) => {
          this.dropdowns.landen = (response.data).data;
        });
    },

    retrieveKleuren: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/kleuren/oog`)
        .then((response) => {
          this.dropdowns.kleuren.oog = (response.data).data;
        });

      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/kleuren/haar`)
        .then((response) => {
          this.dropdowns.kleuren.haar = (response.data).data;
        });
    },

    retrieveKledingmaten: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/kledingmaten`)
        .then((response) => {
          this.dropdowns.kledingmaten = (response.data).data;
        });
    },

    retrieveUiterlijken: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/uiterlijken`)
        .then((response) => {
          this.dropdowns.uiterlijken = (response.data).data;
        });
    },

    retrieveCupmaten: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/cupmaten`)
        .then((response) => {
          this.dropdowns.cupmaten = (response.data).data;
        });
    },

    retrieveHaarstijlen: function () {
      axios.get(`${helpers.attribute('api_endpoint')}/api/dashboard/haarstijlen`)
        .then((response) => {
          this.dropdowns.haarstijlen = (response.data).data;
        });
    },

    formatDate(dateStr) {
      if (!dateStr) return '';

      const parts = dateStr.split('-');
      if (parts.length !== 3) return dateStr; // Return the original string if format is unexpected

      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    },



    submit: function () {
      // this.emailConfirmed = false;
      this.submitted = true;
      this.loading = true;

      // if(!this.emailConfirmed){

      // }

      // Loop trough all boolean values and convert them to 1 or 0
      Object.keys(this.form.data).forEach(key => {
        if (typeof this.form.data[key] === 'boolean') {
          this.form.data[key] = this.form.data[key] ? 1 : 0;
        }
      });



      let formData = new FormData();
      formData.append('voornaam', this.form.data.voornaam);
      formData.append('voorvoegsels', this.form.data.voorvoegsels);
      formData.append('achternaam', this.form.data.achternaam);
      formData.append('email', this.form.data.email);
      formData.append('opdracht_id', this.form.data.opdracht_id);
      formData.append('kandidaat', this.form.data.kandidaat);
      formData.append('danser', this.form.data.danser);
      formData.append('acteur', this.form.data.acteur);
      formData.append('musical_acteur', this.form.data.musical_acteur);
      formData.append('zanger', this.form.data.zanger);
      formData.append('model', this.form.data.model);
      formData.append('figurant', this.form.data.figurant);
      formData.append('presentator', this.form.data.presentator);
      formData.append('entertainer', this.form.data.entertainer);
      formData.append('av', this.form.data.av);
      formData.append('privacy', this.form.data.privacy);
      formData.append('social_media', this.form.data.social_media);
      formData.append('geslacht', this.form.data.geslacht);
      formData.append('geboortedatum', this.formatDate(this.form.data.geboortedatum));
      formData.append('straatnaam', this.form.data.straatnaam);
      formData.append('huisnummer', this.form.data.huisnummer);
      formData.append('huisnummer_toevoeging', this.form.data.huisnummer_toevoeging);
      formData.append('postcode', this.form.data.postcode);
      formData.append('plaats', this.form.data.plaats);
      formData.append('land', this.form.data.land);
      formData.append('telefoonnummer', this.form.data.telefoonnummer);
      formData.append('rijbewijs', this.form.data.rijbewijs);
      formData.append('uiterlijk', this.form.data.uiterlijk);
      formData.append('oogkleur', this.form.data.oogkleur);
      formData.append('lengte_in_cm', this.form.data.lengte_in_cm);
      formData.append('gewicht_in_kg', this.form.data.gewicht_in_kg);
      formData.append('haarkleur', this.form.data.haarkleur);
      formData.append('haarstijl', this.form.data.haarstijl);
      formData.append('haarlengte', this.form.data.haarlengte);
      formData.append('kledingmaat_boven', this.form.data.kledingmaat_boven);
      formData.append('kledingmaat_onder', this.form.data.kledingmaat_onder);
      formData.append('broek_lengtemaat', this.form.data.broek_lengtemaat);
      formData.append('broek_breedtemaat', this.form.data.broek_breedtemaat);
      formData.append('omtrek_hoofd_in_cm', this.form.data.omtrek_hoofd_in_cm);
      formData.append('omtrek_borst_in_cm', this.form.data.omtrek_borst_in_cm);
      formData.append('omtrek_taille_in_cm', this.form.data.omtrek_taille_in_cm);
      formData.append('omtrek_heup_in_cm', this.form.data.omtrek_heup_in_cm);
      formData.append('boordmaat', this.form.data.boordmaat);
      formData.append('cupmaat', this.form.data.cupmaat);
      formData.append('cupmaat_omvangsmaat', this.form.data.cupmaat_omvangsmaat);
      formData.append('schoenmaat', this.form.data.schoenmaat);
      formData.append('bril', this.form.data.bril);
      formData.append('lenzen', this.form.data.lenzen);
      formData.append('snor', this.form.data.snor);
      formData.append('baard', this.form.data.baard);
      formData.append('bijzonderheden_uiterlijk', this.form.data.bijzonderheden_uiterlijk);
      formData.append('sport_en_hobby', this.form.data.sport_en_hobby);
      formData.append('bijzonderheden_overig', this.form.data.bijzonderheden_overig);
      formData.append('akkoord_voorwaarden', this.form.data.akkoord_voorwaarden);
      formData.append('akkoord_bijzondere_persoonsgegevens', this.form.data.akkoord_bijzondere_persoonsgegevens);
      formData.append('showreel', this.form.data.showreel);

      for (var p_i = 0; p_i < this.form.data.pictures.length; p_i++) {
        formData.append(`pictures[${p_i}]`, this.form.data.pictures[p_i]);
      }

      for (var d_i = 0; d_i < this.form.data.documents.length; d_i++) {
        formData.append(`documents[${d_i}]`, this.form.data.documents[d_i]);
      }

      axios.post(`${helpers.attribute('api_endpoint')}/api/dashboard/users/create_talent_aanmelding`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          this.form.response = response.data;
          this.form.errors = helpers.setAllObjectProperties(this.form.errors, []);
          this.done = true;

          helpers.scrollIntoView('#stent-talent-toevoegen');
        })
        .catch((error) => {
          this.form.errors = {
            ...helpers.setAllObjectPropertiesToArray(this.form.errors),
            ...(error.response !== undefined ? error.response.data.errors : []),
          };

          this.done = false;
        })
        .finally(() => {
          this.loading = false;

          helpers.scrollIntoView('.stent-form-errors', {
            block: 'center',
          });
        });
    },

    setPicturesFiles() {
      this.form.data.pictures = helpers.fileListToArray(this.form.data.pictures)
        .concat(
          helpers.fileListToArray(this.$refs.pictures.files)
        );
    },

    removePicturesFile(index) {
      helpers.removeFromArrayByIndex(this.form.data.pictures, index);
    },

    setDocumentsFiles() {
      this.form.data.documents = helpers.fileListToArray(this.form.data.documents)
        .concat(
          helpers.fileListToArray(this.$refs.documents.files)
        );
    },

    removeDocumentsFile(index) {
      helpers.removeFromArrayByIndex(this.form.data.documents, index);
    },
  },
};
</script>
